import styled from "styled-components";

export const SearchWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  align-content: flex-start;
  gap: 2.4rem;
  align-self: stretch;
  width: 100%;
  flex-wrap: no-wrap;
`;
